<template>
  <div class="sequence-preview">
    <div class="sequence-preview-outer-container" v-if="sequence.$ready">
      <div class="sequence-preview-inner-container" v-if="sequenceItemList">
        <workflow-sequence-header
          :sequence="sequence"
          :show-connection="sequenceItemList.length > 0"
          :dirty="false"
          :is-editable="false"
          :user-override-template-repeat="userRepeat" />

        <component
          v-for="(item, idx) in sequenceItemList"
          :key="'x-item-'+item.groupId+'-'+item.id+'-'+idx"
          v-bind:is="item.groupId === 1 ? 'workflow-primitive' : 'workflow-composite'"
          v-model="sequenceItemList[ idx ]"
          :show-connection="idx !== sequenceItemList.length - 1"
          :is-editable="false">
        </component>
      </div>

      <!-- <pre class="mini-pre m-2" style="overflow: scroll; width: 98%;">{{ sequenceItemList }}</pre> -->
    </div>
    <div class="" v-else>
      Loading...
    </div>
  </div>
</template>

<script>
import WorkflowSequenceHeader from '@/components/RoutineCreatorPage/Elements/WorkflowSequenceHeader'
import WorkflowComposite from '@/components/RoutineCreatorPage/Elements/WorkflowComposite'
import WorkflowPrimitive from '@/components/RoutineCreatorPage/Elements/WorkflowPrimitive'

import '@/components/RoutineCreatorPage/Style/workflow_without_bootstrap.css'

export default {
  name: "PreviewSequence",
  props: {
    sequenceId: { required: true },
    userRepeat: {}
  },
  data: () => ({
  }),
  computed: {
    sequence() {
      return this.$models.sequence.subscribeNode( this.sequenceId )
    },
    sequenceItemList: {
      get() {
        return this.sequence ? this.sequence.sequenceItemList : [];
      },
      set( items ) {
        console.log("SET SEQUENCE", items);
      }
    },
  },
  components: {
    WorkflowSequenceHeader,
    WorkflowComposite,
    WorkflowPrimitive,
  }
};
</script>

<style>
</style>
